module.exports = __webpack_public_path__ + "static/media/mountroyal.d6228449.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Splash/images/mountroyal.png
// module id = 1348
// module chunks = 0